import React, { Component } from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { connect } from "react-redux";
import * as postActions from "../../../store/action/post";
import * as royaltiesActions from "../../../store/action/royalties_editor";
import RoyaltiesEditorService from "../../../services/RoyaltiesEditorService";
import RoyaltiesPhotographerService from "../../../services/RoyaltiesPhotographerService";
import CreatorItem from './creator-item/creator-item'
import localStorage from '../../../utils/local-storage'
import { udpateLogPost } from "../../../utils/common"
import _ from 'lodash'
import ApiService from "../../../services/ApiService";
import moment from 'moment';

class RoyaltiesTab extends Component {
  constructor(props) {
    super(props);
    const {post: {currentPost}} = props;
    const royalties_editor = currentPost.royalties_editor ? currentPost.royalties_editor._id : '';
    const royalties_editor_value = currentPost.royalties_editor_value ? currentPost.royalties_editor_value._id : '';
    const royalties_photographer = currentPost.royalties_photographer ? currentPost.royalties_photographer._id : '';
    const royalties_photographer_value = currentPost.royalties_photographer_value ? currentPost.royalties_photographer_value._id : '';
    this.state = {
      royalties_list: [],
      royalties_editor,
      royalties_editor_value,
      royalties_photographer,
      royalties_photographer_value,
      checkClass: '',
      layoutName: '',
      postRevision: null
    };
    this.timeoutToGetEditor = null;
    this.timeoutToGetPhotographer = null;
  }

  componentDidMount() {
    ApiService.get('/royalties-lists')
    .then(data => {
      this.setState({
        royalties_list: data
      })
    })
    .catch(console.log);
  }

  static getDerivedStateFromProps(props, state){
    // console.log(props, state);
    const {post: { currentPost } } = props;
    const {royalties_editor,
      royalties_editor_value,
      royalties_photographer,
      royalties_photographer_value} = currentPost;
    
    const updates = {};
    if(_.isString(royalties_editor)){
      updates.royalties_editor = royalties_editor;
    }
    if(_.isString(royalties_editor_value)){
      updates.royalties_editor_value = royalties_editor_value;
    }
    if(_.isString(royalties_photographer)){
      updates.royalties_photographer = royalties_photographer;
    }
    if(_.isString(royalties_photographer_value)){
      updates.royalties_photographer_value = royalties_photographer_value;
    }

    if(!_.isEmpty(updates)) {
      return updates
    }
    return null;
  }

  getRoyaltiesLabel(id) {
    const item = this.state.royalties_list.find(r => r._id == id);
    if(item) {
      return item.label;
    }
    return false;
  }

  componentDidUpdate(prevProps, prevState){
    const {post: { currentPost } } = this.props;
    let newLogs = [];
    
    //Nhuận but thay đổi
    if(prevState.royalties_editor_value !== this.state.royalties_editor_value){
      if(!prevState.royalties_editor_value) {
        newLogs.push(udpateLogPost(`set nhuận bút: ${this.getRoyaltiesLabel(this.state.royalties_editor_value)}`));
      } else {
        newLogs.push(udpateLogPost(`thay đổi nhuận bút: ${this.getRoyaltiesLabel(prevState.royalties_editor_value)} => ${this.getRoyaltiesLabel(this.state.royalties_editor_value)}`));
      }
      
    }

    // nhuan video thay doi
    if(prevState.royalties_photographer_value !== this.state.royalties_photographer_value){
      if(!prevState.royalties_photographer_value) {
        newLogs.push(udpateLogPost(`set nhuận ảnh: ${this.getRoyaltiesLabel(this.state.royalties_photographer_value)}`));
      } else {
        newLogs.push(udpateLogPost(`thay đổi nhuận ảnh: ${this.getRoyaltiesLabel(prevState.royalties_photographer_value)} => ${this.getRoyaltiesLabel(this.state.royalties_photographer_value)}`));
      }
    }

    if(newLogs.length){
      const newLogsStr = newLogs.join(',');
      let log_action = `${this.props.post.currentPost.log_action}${newLogsStr}`;
      currentPost.log_action = log_action;
      this.props.setCurrentPost(currentPost);
      
    }
    
  }

  render() {
    const { checkClass, layoutName, post: { currentPost } } = this.props;
    const _user = localStorage.get('_user');
    let valueRoyaltiesEditor = currentPost.royalties_editor;
    if(!valueRoyaltiesEditor){
      valueRoyaltiesEditor = _user.royalties_editors ? _user.royalties_editors[0] : null
      if(valueRoyaltiesEditor){
        currentPost.royalties_editor = valueRoyaltiesEditor;
        this.props.setCurrentPost(currentPost);
      }
    }

    return (
      <div className={(layoutName !== 'layout-pc' ? 'row card' : '')}>
        {
          layoutName !== 'layout-pc' &&
          <div className={"card-header col-12 " + (checkClass)}>
            <h4 className="card-title">Chấm nhuận</h4>
            <div className="card-tools">
              <button type="button" className="btn btn-tool" data-card-widget="collapse">
                <i className="fas fa-minus"></i>
              </button>
            </div>
          </div>
        }
        <div className="card-body col-12">
          <div className="row">
            <div className="editor-name col mb-3">
              <CreatorItem checkRequireData={this.props.checkRequireData} creatable={true} functioncreate="createEditorV" functioncall="getRoyaltiesEditor" newapi="/royalties-editors" valueinstore="listRoyaltiesEditor" posttype="royalties_editor"
                type="royalties_editor" selectedValue={valueRoyaltiesEditor}
                label="Biên tập viên" placeholder="Biên tập viên" 
                handleRoyaltyRevision={(obj) => this.handleRoyaltyRevision("Set biên tập viên", obj)}
                />
            </div>
            {this.props.userInfo &&
              this.props.userInfo.role &&
              (this.props.userInfo.role.name.toLowerCase() == "tbt" || this.props.userInfo.role.name.toLowerCase() == "superadmin") && (
                <div className="editor-royalties col-12 col-md-4 mb-3">

                  <CreatorItem creatable={false} functioncall="getRoyaltiesList" valueinstore="listRoyalties" posttype="royalties_editor_value"
                    type="royalties_editor_value" selectedValue={currentPost.royalties_editor_value}
                    label="Nhuận" placeholder="" 
                    handleRoyaltyRevision={(obj) => this.handleRoyaltyRevision("Set nhuận biên tập viên", obj)}
                    />
                </div>
              )}
          </div>
          <div className="row">
            <div className="photographer-name col mb-3">
              <CreatorItem creatable={true} isClearable={true} functioncreate="createPhotoV" functioncall="getRoyaltiesPhoto" newapi="/royalties-photographers" valueinstore="listRoyaltiesPhoto" posttype="royalties_photographer"
                type="royalties_photographer" selectedValue={currentPost.royalties_photographer}
                label="Photographer" placeholder="Photographer" 
                handleRoyaltyRevision={(obj) => this.handleRoyaltyRevision("Set photographer", obj)}
              />
            </div>
            {this.props.userInfo &&
              this.props.userInfo.role &&
              (this.props.userInfo.role.name.toLowerCase() == "tbt" || this.props.userInfo.role.name.toLowerCase() == "superadmin") && (
                <div className="photographer-royalties col-12 col-md-4  mb-3">
                  <CreatorItem creatable={false} functioncall="getRoyaltiesList" valueinstore="listRoyalties" posttype="royalties_photo_value"
                    type="royalties_photo_value" selectedValue={currentPost.royalties_photo_value}
                    label="Nhuận" placeholder="" 
                    handleRoyaltyRevision={(obj) => this.handleRoyaltyRevision("Set nhuận photographer", obj)}
                  />
                </div>
              )}
          </div>

        </div>
      </div>


    );
  }
  // Load Photographer list
  loadPhotographerList = (input, callback) => {
    clearInterval(this.timeoutToGetPhotographer);

    this.timeoutToGetPhotographer = setTimeout(() => {
      RoyaltiesPhotographerService.filter(input)
        .then(result => {
          const selectedIdx = result.findIndex(item => {
            return (
              item.id ==
              (this.props.currentPost.royalties_photographer &&
                this.props.currentPost.royalties_photographer.id)
            );
          });

          if (selectedIdx < 0) {
            if (this.props.currentPost.royalties_photographer) {
              result.push(this.props.currentPost.royalties_photographer);
            }
          }

          callback(
            result.map(item => {
              return { value: item.slug, label: item.name, id: item.id };
            })
          );
        })
        .catch(err => {
          callback([]);
        });
    }, 2000);
  };

  // Load editor list
  loadEditorList = (input, callback) => {
    clearInterval(this.timeoutToGetEditor);

    this.timeoutToGetEditor = setTimeout(() => {
      RoyaltiesEditorService.filter(input)
        .then(result => {
          const selectedIdx = result.findIndex(item => {
            return (
              item.id ==
              (this.props.currentPost.royalties_editor &&
                this.props.currentPost.royalties_editor.id)
            );
          });

          if (selectedIdx < 0) {
            if (this.props.currentPost.royalties_editor) {
              result.push(this.props.currentPost.royalties_editor);
            }
          }
          // console.log("editor result: ", result);

          callback(
            result.map(item => {
              return { value: item.slug, label: item.name, id: item.id };
            })
          );
        })
        .catch(err => {
          console.log("erro: ", err);

          callback([]);
        });
    }, 2000);
  };

  onEditorSelected = value => {
    const data = {
      ...this.props.currentPost,
      royalties_editor: value.id
    };
    console.log("onEditorSelected: ", value);
    this.props.setCurrentPost(data);
    this.setState({
      editor: value
    });
  };

  onEditorRoyaltiesSelected = value => {
    console.log("onEditorRoyaltiesSelected: ", value);
    const data = {
      ...this.props.currentPost,
      royalties_editor_value: value.value
    };
    console.log(this.props.currentPost.log_action)
    this.props.setCurrentPost(data);
    this.setState({
      editorRoyalties: value
    });
  };

  onPhotographerSelected = value => {
    // console.log("onPhotographerSelected: ", value);
    const data = {
      ...this.props.currentPost,
      royalties_photographer: value.id
    };
    this.props.setCurrentPost(data);
    this.setState({
      photographer: value
    });
  };

  onPhotographerRoyaltiesSelected = value => {
    // console.log("onPhotographerRoyaltiesSelected: ", value);
    const data = {
      ...this.props.currentPost,
      royalties_photographer_value: value.value
    };
    this.props.setCurrentPost(data);
    this.setState({
      photographerRoyalties: value
    });
  };

  handleRoyaltyRevision = (preText, valueObj) => {    
    const { post: { currentPost } } = this.props;
    const postRevision = this.state.postRevision || this.props.postRevision;
    const user = localStorage.get("_user");

    if (postRevision && currentPost.id) {
      const royaltyLog = `${user.username} - ${preText} - ${valueObj ? valueObj.label : null} - ${moment().format('DD/MM/YYYY HH:mm')}<br/>`;
      ApiService.put(`/post-revisions/${postRevision.id}`, {
        royalty: `${postRevision.royalty || ""}${royaltyLog}`
      }).then(data => {
        this.setState({
          postRevision: data
        });
      })
    }
  }
}

RoyaltiesTab.propTypes = {};

const mapStateToProps = state => ({
  post: state.post,
  userInfo: state.loginInfo && state.loginInfo.userInfo,
  royalties_list: state.config.royalties_list || [],
  currentPost: state.post.currentPost
});

const mapDispatchToProps = dispatch => ({
  setCurrentPost: post => {
    dispatch(postActions.setCurrentPost(post));
  },
  getRoyaltiesEditors: value => {
    dispatch(royaltiesActions.getRoyaltiesEditors(value));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(RoyaltiesTab);
